// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4AgsYQ5T6emGSKZgzXTY6g\\=\\={align-items:center;display:grid;grid-template-columns:auto 1fr}.H4cVWaBIktc3eexPiEt02Q\\=\\={margin-left:.7rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prices": "_4AgsYQ5T6emGSKZgzXTY6g==",
	"original": "H4cVWaBIktc3eexPiEt02Q=="
};
module.exports = ___CSS_LOADER_EXPORT___;
